module.exports = __webpack_public_path__ + "media/src/components/EmployerProfile/img/no-logo-68d2f770e7655f2f18403c2acf677be2.png";